import React, { useState } from 'react';
import PropTypes from 'prop-types';
import '../../../css/svg.css';

const PacificMap = ({ onStateClick }) => {
	const [selectedState, setSelectedState] = useState(null);
	const [isVisible, setIsVisible] = useState(true);

	const handleStateClick = (area) => {
		setSelectedState(area);
		setIsVisible(false);
		setTimeout(() => {
			onStateClick(area);
		}, 500);
		console.log('State Clicked: %s', area);
	};

	return (
		<svg
			id='pacific-region'
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 1400 3000'
			className={`map ${!isVisible ? 'hidden' : ''}`}
      style={{
        maxWidth: '100%',
        maxHeight: '90%',
      }}>
			<polygon
				id='WA'
				points='438 117 508 173 537 180 588 195 599 212 618 227 633 216 636 235 647 254 647 268 629 280 627 300 633 321 634 341.74 648 341.74 648 293 676 256 676 166 678 157 683 145 681 134 672 120 666 97 673 81 884 140 1265 229 1184 640 1184 707 1157 701 1053 678 964 656 925 656 831 662 751 659 634.65 621.8 584 631 560 623 540 602 540 546 519 516 468 484 431 485 431 470 413 453 421 435 429 439 446 433 446 404 439 386 439 371 448 367 469 361 438 342 438 206 434 165 438 117'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='10'
				data-area='WA'
				className={`polygon ${selectedState === 'WA' ? 'selected' : ''}`}
				onClick={() => handleStateClick('WA')}
			/>
			<polygon
				id='OR'
				points='211 1128 195 1101.3 195 1065 211 1027.71 211 973 247 911 278 876 289 843 325 762 348 709 372 648 390 578 409 520 431 485 468 484 519 516 540 546 540 602 560 623 584 631 634.65 621.8 751 659 831 662 925 656 964 656 1053 678 1157 701 1184 707 1208 745 1218 766 1212 787 1181 830 1154 874 1096 936 1096 966.46 1120 987 1113 1018 1096 1058.24 1039 1333 688 1255 211 1128'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='10'
				data-area='OR'
				className={`polygon ${selectedState === 'OR' ? 'selected' : ''}`}
				onClick={() => handleStateClick('OR')}
			/>
			<polygon
				id='CA'
				points='211 1128 195 1170.13 174 1260 150 1318 125 1369 128 1401 150 1474 145 1523 130 1593 133 1649 148 1686 174 1728 185 1749 187 1801 225 1834 235 1803 260 1790 302 1790 329 1805 350 1821 354 1840 329 1831 306 1815 266 1807 248 1816 250 1850 258 1871 268 1905 242 1885 230 1851 214 1874 218 1925 242 1995 258 2034 251 2072 241 2095 242 2124 268 2179 310 2257 343 2320 340 2349 329 2380 350 2411 375 2441 465 2499 544 2544 577 2567 588 2592 590 2618 623 2636 657 2666 684 2703 698 2738 699 2790 696 2818 712 2844 1018 2874 1054 2871 1073 2853 1062 2836 1045 2824 1046 2783 1062 2756 1088 2721 1094 2702 1099 2680 1119 2657 1146 2637 1146 2620 1126 2593 1121 2558 1112 2537 1109 2500 577 1728 688 1255 211 1128'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='10'
				data-area='CA'
				className={`polygon ${selectedState === 'CA' ? 'selected' : ''}`}
				onClick={() => handleStateClick('CA')}
			/>
			<rect x='152' y='1707' width='209' height='36' fill='none' className='shape' />
			<path
				d='M161.12,1734.03c1.32.89,3.14,1.55,5.16,1.55,2.73,0,5.24-1.63,5.24-4.55,0-1.8-1.02-3.15-3.55-4.54-3.1-1.68-4.83-3.62-4.83-6.22,0-4.34,3.73-7.12,8.19-7.12,2.37,0,4.14.69,4.97,1.26l-1.06,2.44c-.76-.46-2.28-1.16-4.21-1.14-3,0-4.8,1.97-4.81,3.96,0,1.97,1.23,3.09,3.77,4.5,2.99,1.6,4.63,3.51,4.63,6.49,0,4.19-3.29,7.5-8.75,7.5-2.43,0-4.82-.79-5.84-1.69l1.08-2.44Z'
				className='shape'
			/>
			<path
				d='M192.16,1737.78c-.01-1.05.16-2.69.39-4.5h-.08c-1.88,3.62-4.28,4.89-6.74,4.89-3.08,0-5.01-2.45-5.01-5.75,0-6.06,4.46-12.45,12.04-12.45,1.67,0,3.49.29,4.7.66l-1.78,9.07c-.58,3.03-.82,6.14-.74,8.07h-2.78ZM194.1,1722.6c-.42-.14-1.06-.25-2.07-.25-4.51,0-8.19,4.69-8.21,9.53-.01,1.95.67,3.84,2.97,3.84,2.5,0,5.42-3.25,6.29-7.87l1.01-5.25Z'
				className='shape'
			/>
			<path
				d='M214.27,1737.09c-.89.44-2.69,1.07-5.06,1.07-4.48,0-6.7-3.04-6.7-6.73,0-5.94,4.42-11.44,10.68-11.44,1.62,0,3.09.47,3.62.79l-.85,2.37c-.69-.33-1.65-.66-2.96-.66-4.52,0-7.38,4.46-7.38,8.56,0,2.83,1.48,4.66,4.34,4.66,1.77,0,3.13-.54,4.02-.97l.29,2.36Z'
				className='shape'
			/>
			<path
				d='M220.44,1737.78l2.13-11.21c.43-2.27.69-4.58.88-6.19h2.63c-.14,1.21-.28,2.43-.48,3.78h.1c1.14-2.38,3-4.18,5.34-4.18.28,0,.62.02.85.06l-.58,2.95c-.21-.04-.47-.06-.81-.06-2.58,0-4.89,3.13-5.64,7.18l-1.44,7.68h-2.98Z'
				className='shape'
			/>
			<path
				d='M245.77,1737.78c-.01-1.05.16-2.69.39-4.5h-.08c-1.88,3.62-4.28,4.89-6.74,4.89-3.08,0-5.01-2.45-5.01-5.75,0-6.06,4.46-12.45,12.04-12.45,1.67,0,3.49.29,4.7.66l-1.78,9.07c-.58,3.03-.82,6.14-.74,8.07h-2.78ZM247.7,1722.6c-.42-.14-1.06-.25-2.07-.25-4.51,0-8.19,4.69-8.21,9.53-.01,1.95.67,3.84,2.97,3.84,2.5,0,5.42-3.25,6.29-7.87l1.01-5.25Z'
				className='shape'
			/>
			<path
				d='M255.97,1737.78l2.31-12.34c.38-1.94.62-3.62.81-5.07h2.63l-.46,3.27h.08c1.63-2.43,3.82-3.66,6.13-3.66,2.65,0,3.94,1.68,4.07,3.88,1.56-2.52,3.78-3.84,6.4-3.88,2.02,0,4.23,1.29,4.23,4.57,0,.81-.11,1.98-.29,2.96l-1.94,10.28h-2.92l1.88-10.03c.13-.67.25-1.55.25-2.27,0-1.84-.7-3.02-2.62-3.02-2.18,0-4.75,2.5-5.47,6.4l-1.66,8.92h-2.91l1.94-10.22c.15-.78.23-1.45.23-2.13,0-1.47-.41-2.98-2.61-2.98s-4.89,2.88-5.56,6.57l-1.61,8.75h-2.92Z'
				className='shape'
			/>
			<path
				d='M300.49,1736.78c-1.32.74-3.42,1.38-5.76,1.38-4.62,0-6.62-3.15-6.62-7,0-5.24,3.89-11.18,9.5-11.18,3.31,0,5.11,1.97,5.11,4.47,0,4.57-5.15,5.78-11.59,5.65-.15.75-.04,2.38.35,3.31.7,1.57,2.08,2.34,3.87,2.34,2.07,0,3.62-.62,4.69-1.19l.44,2.23ZM297.19,1722.3c-2.84,0-4.99,2.78-5.72,5.5,4.69.06,8.36-.57,8.36-3.28,0-1.43-1.09-2.22-2.65-2.22Z'
				className='shape'
			/>
			<path
				d='M307.12,1737.78l2.33-12.34c.39-1.94.62-3.62.82-5.07h2.68l-.45,3.42h.07c1.57-2.45,3.91-3.82,6.46-3.82,2.07,0,4.4,1.19,4.4,4.83,0,.78-.14,1.88-.31,2.81l-1.93,10.16h-2.98l1.9-10.06c.12-.68.24-1.49.24-2.23,0-1.75-.67-3.03-2.73-3.03s-5.16,2.55-5.95,6.86l-1.57,8.46h-2.98Z'
				className='shape'
			/>
			<path
				d='M337.02,1715.69l-.9,4.68h4.16l-.47,2.34h-4.16l-1.6,8.46c-.19.97-.35,1.87-.35,2.78,0,1.04.49,1.69,1.65,1.69.54,0,1.02-.04,1.41-.14l-.14,2.35c-.53.2-1.44.32-2.31.32-2.63,0-3.66-1.6-3.66-3.38,0-1.01.13-2.01.38-3.27l1.7-8.81h-2.49l.45-2.34h2.5l.73-3.92,3.1-.75Z'
				className='shape'
			/>
			<path
				d='M359.93,1727.22c0,5.38-3.82,10.96-9.67,10.96-4.36,0-6.8-3.23-6.8-7.15,0-5.75,3.99-11.05,9.66-11.05,4.69,0,6.81,3.55,6.81,7.24ZM346.55,1730.91c0,2.83,1.57,4.9,4.13,4.9,3.51,0,6.18-4.55,6.18-8.6,0-2.03-.94-4.87-4.06-4.87-3.76,0-6.25,4.58-6.25,8.57Z'
				className='shape'
			/>
			<polygon
				points='385.39 1680.08 385.76 1695 401.45 1695 385.99 1704.22 386.36 1719.15 376.43 1709.92 360.97 1719.15 370.3 1704.22 360.37 1695 376.06 1695 385.39 1680.08'
				className='shape'
			/>
			<rect x='478.15' y='707' width='109.85' height='38' fill='none' className='shape' />
			<path
				d='M479.64,735.03c1.32.89,3.14,1.55,5.16,1.55,2.73,0,5.24-1.63,5.24-4.55,0-1.8-1.02-3.15-3.55-4.54-3.1-1.68-4.83-3.62-4.83-6.22,0-4.34,3.73-7.12,8.19-7.12,2.37,0,4.14.69,4.97,1.26l-1.06,2.44c-.76-.46-2.28-1.16-4.21-1.14-3,0-4.8,1.97-4.81,3.96,0,1.97,1.23,3.09,3.77,4.5,2.99,1.6,4.63,3.51,4.63,6.49,0,4.19-3.29,7.5-8.75,7.5-2.43,0-4.82-.79-5.84-1.69l1.08-2.44Z'
				className='shape'
			/>
			<path
				d='M510.69,738.78c-.01-1.05.16-2.69.39-4.5h-.08c-1.88,3.62-4.28,4.89-6.74,4.89-3.08,0-5.01-2.45-5.01-5.75,0-6.06,4.46-12.45,12.04-12.45,1.67,0,3.49.29,4.7.66l-1.78,9.07c-.58,3.03-.82,6.14-.74,8.07h-2.78ZM512.63,723.6c-.42-.14-1.06-.25-2.07-.25-4.51,0-8.19,4.69-8.21,9.53-.01,1.95.67,3.84,2.97,3.84,2.5,0,5.42-3.25,6.29-7.87l1.01-5.25Z'
				className='shape'
			/>
			<path d='M520.83,738.78l4.87-25.56h2.98l-4.88,25.56h-2.98Z' className='shape' />
			<path
				d='M544.5,737.78c-1.32.74-3.42,1.38-5.76,1.38-4.62,0-6.62-3.15-6.62-7,0-5.24,3.89-11.18,9.5-11.18,3.31,0,5.11,1.97,5.11,4.47,0,4.57-5.15,5.78-11.59,5.65-.15.75-.04,2.38.35,3.31.7,1.57,2.08,2.34,3.87,2.34,2.07,0,3.62-.62,4.69-1.19l.44,2.23ZM541.19,723.3c-2.84,0-4.99,2.78-5.72,5.5,4.69.06,8.36-.57,8.36-3.28,0-1.43-1.09-2.22-2.65-2.22Z'
				className='shape'
			/>
			<path
				d='M551.13,738.78l2.31-12.34c.38-1.94.62-3.62.81-5.07h2.63l-.46,3.27h.08c1.63-2.43,3.82-3.66,6.13-3.66,2.65,0,3.94,1.68,4.07,3.88,1.56-2.52,3.78-3.84,6.4-3.88,2.02,0,4.23,1.29,4.23,4.57,0,.81-.11,1.98-.29,2.96l-1.94,10.28h-2.92l1.88-10.03c.13-.67.25-1.55.25-2.27,0-1.84-.7-3.02-2.62-3.02-2.18,0-4.75,2.5-5.47,6.4l-1.66,8.92h-2.91l1.94-10.22c.15-.78.23-1.45.23-2.13,0-1.47-.41-2.98-2.61-2.98s-4.89,2.88-5.56,6.57l-1.61,8.75h-2.92Z'
				className='shape'
			/>
			<polygon
				points='463.39 679.08 463.76 694 479.45 694 463.99 703.22 464.36 718.15 454.43 708.92 438.97 718.15 448.3 703.22 438.37 694 454.06 694 463.39 679.08'
				className='shape'
			/>
			<rect x='624.77' y='380' width='148.23' height='40' fill='none' className='shape' />
			<path
				d='M648.44,398.07c0,4.2-1.54,8.85-4.42,11.72-2.15,2.12-4.97,3.39-8.31,3.39-6.27,0-9.2-4.72-9.2-9.87,0-4.26,1.67-9,4.63-11.89,2.08-2.03,5.08-3.29,8.14-3.29,6.53,0,9.17,4.75,9.17,9.95ZM633.33,393.07c-2.33,2.34-3.68,6.6-3.68,9.99,0,3.94,1.75,7.59,6.5,7.59,2.07,0,4.03-.89,5.54-2.42,2.29-2.3,3.61-6.65,3.61-10.03s-1.13-7.55-6.43-7.55c-2.15,0-4.05.94-5.54,2.43Z'
				className='shape'
			/>
			<path d='M652.94,412.78l4.87-25.56h2.98l-4.88,25.56h-2.98Z' className='shape' />
			<path
				d='M667.9,395.37l1.72,9.36c.39,2,.61,3.29.79,4.59h.09c.46-1.12.97-2.34,1.85-4.26l4.46-9.69h3.17l-6.54,13.23c-1.87,3.77-3.63,6.83-6,9.16-1.95,1.96-4.07,2.79-5.06,3.01l-.73-2.56c.75-.26,2.01-.75,3.19-1.68,1.18-.91,2.43-2.31,3.37-4.02.15-.29.14-.49.09-.79l-3.49-16.35h3.1Z'
				className='shape'
			/>
			<path
				d='M682.85,412.78l2.31-12.34c.38-1.94.62-3.62.81-5.07h2.63l-.46,3.27h.08c1.63-2.43,3.82-3.66,6.13-3.66,2.65,0,3.94,1.68,4.07,3.88,1.56-2.52,3.78-3.84,6.4-3.88,2.02,0,4.23,1.29,4.23,4.57,0,.81-.11,1.98-.29,2.96l-1.94,10.28h-2.92l1.88-10.03c.13-.67.25-1.55.25-2.27,0-1.84-.7-3.02-2.62-3.02-2.18,0-4.75,2.5-5.47,6.4l-1.66,8.92h-2.91l1.94-10.22c.15-.78.23-1.45.23-2.13,0-1.47-.41-2.98-2.61-2.98s-4.89,2.88-5.56,6.57l-1.61,8.75h-2.92Z'
				className='shape'
			/>
			<path
				d='M713.25,419.91l3.49-18.36c.39-2.09.75-4.42.98-6.17h2.73l-.49,3.28h.07c1.58-2.3,3.88-3.67,6.26-3.67,3.77,0,5.36,3.1,5.36,6.29,0,6.13-4.4,11.91-10.2,11.91-1.85,0-3.08-.41-3.75-.78h-.08l-1.41,7.51h-2.97ZM718.15,409.86c.77.6,1.9.96,3.32.96,3.85,0,7.07-4.78,7.07-9.33,0-1.83-.81-4.03-3.34-4.03-2.35,0-5.27,2.67-6.17,7.54l-.88,4.86Z'
				className='shape'
			/>
			<path
				d='M736.6,412.78l3.33-17.41h2.98l-3.33,17.41h-2.98ZM740.48,390.51c.01-1.15.88-2.02,1.96-2.02s1.78.78,1.78,1.87c-.04,1.18-.87,2.01-2.02,2.01-1.05,0-1.74-.8-1.72-1.86Z'
				className='shape'
			/>
			<path
				d='M759.27,412.78c-.01-1.05.16-2.69.39-4.5h-.08c-1.88,3.62-4.28,4.89-6.74,4.89-3.08,0-5.01-2.45-5.01-5.75,0-6.06,4.46-12.45,12.04-12.45,1.67,0,3.49.29,4.7.66l-1.78,9.07c-.58,3.03-.82,6.14-.74,8.07h-2.78ZM761.2,397.6c-.42-.14-1.06-.25-2.07-.25-4.51,0-8.19,4.69-8.21,9.53-.01,1.95.67,3.84,2.97,3.84,2.5,0,5.42-3.25,6.29-7.87l1.01-5.25Z'
				className='shape'
			/>
			<polygon
				points='612.02 349.08 612.39 364 628.08 364 612.62 373.22 612.99 388.15 603.06 378.92 587.6 388.15 596.93 373.22 587 364 602.69 364 612.02 349.08'
				className='shape'
			/>
			<rect x='669.8' y='458.02' width='406.2' height='53.28' fill='none' className='shape' />
			<path
				d='M679.19,510.22l-2.38-48.53h6l1.03,29.09c.18,6.28.06,9.59,0,12.64h.17c1.13-3.17,2.31-6.32,4.99-12.3l13.44-29.43h6.39l1,27.94c.22,6.29.22,10.5.11,13.7h.16c1.43-4.17,2.88-8.07,4.74-12.49l13.08-29.14h6.26l-22.52,48.53h-6.32l-1.24-27.61c-.26-5.64-.2-8.4.11-13.96h-.18c-1.62,4.65-2.91,8.37-4.9,12.77l-13.54,28.8h-6.4Z'
				className='shape'
			/>
			<path
				d='M757.72,510.22c-.03-2.1.33-5.39.78-9h-.15c-3.76,7.23-8.57,9.79-13.48,9.79-6.17,0-10.01-4.9-10.01-11.51,0-12.13,8.93-24.9,24.08-24.9,3.34,0,6.98.57,9.4,1.32l-3.55,18.15c-1.15,6.06-1.63,12.28-1.47,16.14h-5.57ZM761.59,479.85c-.84-.27-2.13-.49-4.14-.49-9.02,0-16.38,9.38-16.41,19.07-.03,3.89,1.35,7.68,5.94,7.68,5,0,10.85-6.49,12.59-15.75l2.02-10.51Z'
				className='shape'
			/>
			<path
				d='M778.41,504.17c1.64.98,4.62,2.17,7.49,2.17,4.02,0,6.63-2.6,6.63-5.69,0-2.72-1.22-4.42-4.84-6.42-4.03-2.23-6.3-5.31-6.3-8.88,0-6.08,5.28-10.74,12.62-10.74,3.16,0,5.94.85,7.25,1.73l-1.68,4.51c-1.2-.7-3.4-1.59-6-1.59-3.64,0-6.21,2.27-6.21,5.23,0,2.56,1.67,4.11,4.79,5.86,3.88,2.19,6.5,5.24,6.5,9.15,0,7.32-5.95,11.48-13.3,11.48-3.75,0-7.08-1.18-8.66-2.39l1.71-4.42Z'
				className='shape'
			/>
			<path
				d='M810.73,510.22l9.72-51.12h5.97l-4.35,22.44h.14c2.99-4.23,7.19-6.93,12.44-6.93,3.95,0,8.67,2.39,8.67,9.33,0,1.86-.23,4.13-.58,5.89l-3.87,20.39h-5.96l3.82-20.12c.25-1.27.47-2.88.47-4.81,0-3.2-1.54-5.72-5.41-5.72-4.62,0-10.41,5.4-11.86,13.2l-3.25,17.45h-5.96Z'
				className='shape'
			/>
			<path
				d='M854.94,510.22l6.65-34.82h5.96l-6.65,34.82h-5.96ZM862.69,465.67c.03-2.3,1.77-4.04,3.93-4.04s3.56,1.57,3.56,3.75c-.08,2.35-1.75,4.02-4.05,4.02-2.11,0-3.47-1.61-3.43-3.73Z'
				className='shape'
			/>
			<path
				d='M877.19,510.22l4.66-24.69c.77-3.87,1.25-7.25,1.64-10.14h5.36l-.9,6.84h.14c3.13-4.9,7.82-7.63,12.92-7.63,4.13,0,8.8,2.38,8.8,9.67,0,1.55-.28,3.76-.62,5.62l-3.87,20.33h-5.96l3.81-20.12c.24-1.35.47-2.97.47-4.46,0-3.49-1.35-6.07-5.46-6.07s-10.33,5.1-11.91,13.72l-3.14,16.93h-5.96Z'
				className='shape'
			/>
			<path
				d='M921.7,518.13c2.11,1.34,5.58,2.28,9.24,2.28,5.86,0,10.45-2.97,12.52-12.4l1.15-5.21h-.18c-3.05,4.99-7.29,7.4-12.11,7.4-7,0-10.6-5.89-10.61-12.06-.02-11.86,8.63-23.53,22.11-23.53,4.04,0,8.44,1.13,11.18,2.43l-5.34,28.78c-1.4,7.38-3.4,12.47-7.02,15.59-3.48,3.02-8.19,3.86-12.16,3.86-4.24,0-8.26-.98-10.44-2.46l1.67-4.67ZM948.46,480.58c-1.1-.55-3.26-1.19-5.76-1.19-8.71,0-14.71,9.11-14.75,17.71-.02,3.86,1.37,8.35,6.67,8.35s10.33-6.47,11.62-13.27l2.22-11.6Z'
				className='shape'
			/>
			<path
				d='M980.47,466.04l-1.79,9.36h8.32l-.93,4.67h-8.33l-3.21,16.93c-.38,1.95-.69,3.74-.69,5.56,0,2.08.99,3.38,3.3,3.38,1.07,0,2.03-.08,2.81-.28l-.29,4.7c-1.06.41-2.88.63-4.62.63-5.26,0-7.33-3.19-7.33-6.76,0-2.03.26-4.01.76-6.53l3.4-17.62h-4.98l.9-4.67h5l1.47-7.85,6.2-1.51Z'
				className='shape'
			/>
			<path
				d='M1026.31,489.09c0,10.76-7.64,21.92-19.35,21.92-8.72,0-13.6-6.46-13.6-14.3,0-11.51,7.99-22.11,19.31-22.11,9.39,0,13.63,7.1,13.63,14.48ZM999.52,496.48c0,5.66,3.15,9.8,8.25,9.8,7.02,0,12.36-9.11,12.36-17.2,0-4.07-1.88-9.74-8.12-9.74-7.53,0-12.5,9.16-12.5,17.14Z'
				className='shape'
			/>
			<path
				d='M1036.23,510.22l4.66-24.69c.77-3.87,1.25-7.25,1.64-10.14h5.36l-.9,6.84h.14c3.13-4.9,7.82-7.63,12.92-7.63,4.13,0,8.81,2.38,8.81,9.67,0,1.55-.28,3.76-.62,5.62l-3.87,20.33h-5.96l3.81-20.12c.24-1.35.47-2.97.47-4.46,0-3.49-1.35-6.07-5.46-6.07s-10.33,5.1-11.91,13.72l-3.14,16.93h-5.96Z'
				className='shape'
			/>
			<rect
				x='537.55'
				y='914.79'
				width='250.45'
				height='53.28'
				fill='none'
				className='shape'
			/>
			<path
				d='M584.89,937.56c0,8.41-3.08,17.7-8.84,23.44-4.3,4.25-9.94,6.77-16.63,6.77-12.54,0-18.4-9.45-18.4-19.75,0-8.53,3.34-18.01,9.25-23.79,4.16-4.06,10.16-6.58,16.27-6.58,13.06,0,18.35,9.51,18.35,19.9ZM554.66,927.57c-4.67,4.68-7.37,13.21-7.37,19.99,0,7.89,3.5,15.18,13,15.18,4.13,0,8.06-1.79,11.08-4.85,4.58-4.59,7.23-13.31,7.23-20.07s-2.26-15.11-12.86-15.11c-4.31,0-8.11,1.88-11.09,4.86Z'
				className='shape'
			/>
			<path
				d='M593.88,966.99l4.26-22.43c.85-4.54,1.38-9.16,1.77-12.39h5.26c-.28,2.42-.56,4.85-.97,7.57h.21c2.28-4.77,6-8.36,10.67-8.36.55,0,1.24.04,1.71.13l-1.16,5.89c-.42-.08-.95-.12-1.63-.12-5.17,0-9.77,6.27-11.28,14.35l-2.88,15.36h-5.96Z'
				className='shape'
			/>
			<path
				d='M647.22,964.99c-2.63,1.48-6.84,2.75-11.51,2.75-9.25,0-13.25-6.3-13.25-14.01,0-10.49,7.79-22.36,19-22.36,6.63,0,10.22,3.95,10.23,8.93,0,9.15-10.31,11.55-23.18,11.31-.29,1.51-.09,4.76.7,6.63,1.4,3.14,4.16,4.68,7.75,4.68,4.14,0,7.25-1.23,9.38-2.39l.88,4.45ZM640.61,936.02c-5.69,0-9.98,5.55-11.44,11,9.38.11,16.73-1.14,16.73-6.57,0-2.86-2.18-4.44-5.3-4.44Z'
				className='shape'
			/>
			<path
				d='M660.78,974.9c2.11,1.34,5.58,2.28,9.24,2.28,5.86,0,10.45-2.97,12.52-12.4l1.15-5.21h-.18c-3.05,4.99-7.29,7.4-12.11,7.4-7,0-10.6-5.89-10.61-12.06-.02-11.86,8.63-23.53,22.11-23.53,4.04,0,8.44,1.13,11.18,2.43l-5.34,28.78c-1.4,7.38-3.4,12.47-7.02,15.59-3.48,3.02-8.19,3.86-12.16,3.86-4.24,0-8.26-.98-10.44-2.46l1.67-4.67ZM687.55,937.34c-1.1-.55-3.26-1.19-5.76-1.19-8.71,0-14.71,9.11-14.75,17.71-.02,3.86,1.37,8.35,6.67,8.35s10.33-6.47,11.62-13.27l2.22-11.6Z'
				className='shape'
			/>
			<path
				d='M737.38,945.86c0,10.76-7.64,21.92-19.35,21.92-8.72,0-13.6-6.46-13.6-14.3,0-11.51,7.99-22.11,19.31-22.11,9.39,0,13.63,7.1,13.63,14.48ZM710.6,953.25c0,5.66,3.15,9.8,8.25,9.8,7.02,0,12.36-9.11,12.36-17.2,0-4.07-1.88-9.74-8.12-9.74-7.53,0-12.5,9.16-12.5,17.14Z'
				className='shape'
			/>
			<path
				d='M747.31,966.99l4.66-24.69c.77-3.87,1.25-7.25,1.64-10.14h5.36l-.9,6.84h.14c3.13-4.9,7.82-7.63,12.92-7.63,4.13,0,8.8,2.38,8.8,9.67,0,1.55-.28,3.76-.62,5.62l-3.87,20.33h-5.96l3.81-20.12c.24-1.35.47-2.97.47-4.46,0-3.49-1.35-6.07-5.46-6.07s-10.33,5.1-11.91,13.72l-3.14,16.93h-5.96Z'
				className='shape'
			/>
			<rect
				x='415.78'
				y='2108.83'
				width='338.22'
				height='53.28'
				fill='none'
				className='shape'
			/>
			<path
				d='M451.57,2159.46c-2.74,1.23-7.14,2.33-12.59,2.33-12.22,0-19.7-7.77-19.7-20.15,0-9.14,3.7-17.85,10.36-23.39,5.02-4.24,11.19-6.51,18.29-6.51,5.4,0,9.27,1.35,10.52,2.33l-1.93,4.82c-1.8-1.09-5.22-2-9.54-2-5.07,0-10.16,1.97-13.9,5.44-4.56,4.27-7.44,11.11-7.44,18.48,0,8.67,3.99,15.84,14.77,15.84,3.66,0,7.67-.73,10.37-2.08l.79,4.88Z'
				className='shape'
			/>
			<path
				d='M486.06,2161.03c-.03-2.1.33-5.39.78-9h-.15c-3.76,7.23-8.57,9.79-13.48,9.79-6.17,0-10.01-4.9-10.01-11.51,0-12.13,8.93-24.9,24.08-24.9,3.34,0,6.98.57,9.4,1.32l-3.55,18.15c-1.15,6.06-1.63,12.28-1.47,16.14h-5.57ZM489.93,2130.67c-.84-.27-2.13-.49-4.14-.49-9.02,0-16.38,9.38-16.42,19.07-.03,3.89,1.35,7.68,5.95,7.68,5,0,10.85-6.49,12.59-15.75l2.02-10.51Z'
				className='shape'
			/>
			<path d='M506.33,2161.03l9.75-51.12h5.97l-9.76,51.12h-5.96Z' className='shape' />
			<path
				d='M528.56,2161.03l6.65-34.82h5.96l-6.65,34.82h-5.96ZM536.31,2116.49c.03-2.3,1.77-4.04,3.93-4.04s3.56,1.57,3.56,3.75c-.08,2.35-1.75,4.02-4.05,4.02-2.11,0-3.47-1.61-3.43-3.73Z'
				className='shape'
			/>
			<path
				d='M551.62,2161.03l5.71-30.14h-4.64l.9-4.69h4.66l.34-1.86c.85-4.83,2.58-9.32,5.7-12.15,2.21-1.99,5.24-3.08,8.26-3.08,2.4,0,3.97.46,4.78.93l-1.3,4.78c-.92-.44-2.14-.68-3.5-.68-4.75,0-7.06,4.63-8.07,10.39l-.3,1.67h7.77l-.92,4.69h-7.74l-5.73,30.14h-5.93Z'
				className='shape'
			/>
			<path
				d='M610.21,2139.9c0,10.76-7.64,21.92-19.35,21.92-8.72,0-13.6-6.46-13.6-14.3,0-11.51,7.99-22.11,19.32-22.11,9.39,0,13.63,7.1,13.63,14.48ZM583.43,2147.29c0,5.66,3.15,9.8,8.25,9.8,7.02,0,12.36-9.11,12.36-17.2,0-4.07-1.88-9.74-8.12-9.74-7.53,0-12.5,9.16-12.5,17.14Z'
				className='shape'
			/>
			<path
				d='M620.14,2161.03l4.26-22.43c.85-4.54,1.38-9.16,1.77-12.39h5.26c-.28,2.42-.57,4.85-.97,7.57h.21c2.28-4.77,6-8.36,10.67-8.36.55,0,1.24.04,1.71.13l-1.16,5.89c-.42-.08-.95-.12-1.62-.12-5.17,0-9.77,6.27-11.28,14.35l-2.88,15.36h-5.96Z'
				className='shape'
			/>
			<path
				d='M648.72,2161.03l4.66-24.69c.77-3.87,1.25-7.25,1.64-10.14h5.36l-.9,6.84h.14c3.13-4.9,7.82-7.63,12.92-7.63,4.13,0,8.8,2.38,8.8,9.67,0,1.55-.28,3.76-.62,5.62l-3.87,20.33h-5.96l3.81-20.12c.24-1.35.47-2.97.47-4.46,0-3.49-1.35-6.07-5.46-6.07s-10.33,5.1-11.91,13.72l-3.14,16.93h-5.96Z'
				className='shape'
			/>
			<path
				d='M692.93,2161.03l6.65-34.82h5.96l-6.65,34.82h-5.96ZM700.68,2116.49c.03-2.3,1.77-4.04,3.93-4.04s3.56,1.57,3.56,3.75c-.08,2.35-1.75,4.02-4.05,4.02-2.11,0-3.47-1.61-3.43-3.73Z'
				className='shape'
			/>
			<path
				d='M738.27,2161.03c-.03-2.1.33-5.39.78-9h-.16c-3.76,7.23-8.57,9.79-13.48,9.79-6.17,0-10.01-4.9-10.01-11.51,0-12.13,8.92-24.9,24.08-24.9,3.34,0,6.98.57,9.4,1.32l-3.55,18.15c-1.15,6.06-1.63,12.28-1.47,16.14h-5.57ZM742.14,2130.67c-.84-.27-2.13-.49-4.14-.49-9.02,0-16.38,9.38-16.41,19.07-.03,3.89,1.35,7.68,5.94,7.68,5,0,10.85-6.49,12.59-15.75l2.02-10.51Z'
				className='shape'
			/>
		</svg>
	);
};

PacificMap.propTypes = {
	onStateClick: PropTypes.func.isRequired,
	selectedState: PropTypes.string,
};

export default PacificMap;
